import React, { useState } from "react";

import { Collapse, Grid, IconButton, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  container: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 2),
    background: theme.palette.backgrounds.secondary,
    boxShadow: `2px 2px 4px 0px rgba(102, 102, 102, 0.20)`,
  },
}));

export const CollapseSection: React.FC<CollapseSectionProps> = ({
  title,
  ...body
}) => {
  const { classes } = useStyles();
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      onClick={handleToggle}
      className={classes.container}
    >
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="body2" color="primary">
          {title}
        </Typography>
        <IconButton aria-label="expand">
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Grid>

      <Collapse in={open}>
        {"text" in body && (
          <Typography variant="body1" fontWeight={400}>
            {body.text}
          </Typography>
        )}
        {"children" in body && <>{body.children}</>}
      </Collapse>
    </Grid>
  );
};

export type CollapseSectionProps =
  | { title: string; text: string }
  | { title: string; children: React.ReactNode };
